import { FirebaseAuth } from '../../../../lib/firebase'
import { isDesktopApp } from './helpers'
import { googleProvider } from './providers'

export const googleSignIn = (): Promise<any> => {
  return isDesktopApp
    ? FirebaseAuth.signInWithRedirect(googleProvider)
    : FirebaseAuth.signInWithPopup(googleProvider)
}
